import { createStore } from 'effector'
import { register } from '~/core/repository'

export const TvCardHorizontalCoversMap = {
  Cover1: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_1.webp',
  Cover2: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_2.webp',
  Cover3: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_3.webp',
  Cover4: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_4.webp',
  Cover5: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_5.webp',
  Cover6: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_6.webp',
  Cover7: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_7.webp',
  Cover8: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_8.webp',
  Cover9: '/img/tvcardcovers/horizontal/tvcardcoverhorizontal_9.webp',
}

export const $tvCardHorizontalCovers = createStore(TvCardHorizontalCoversMap)

register(
  $tvCardHorizontalCovers,
  '$shared/ui/cardCovers/tvCardHorizontalCovers'
)

export const TvCardSquareCoversMap = {
  Cover1: '/img/tvcardcovers/square/tvcardcoversquare_1.webp',
  Cover2: '/img/tvcardcovers/square/tvcardcoversquare_2.webp',
  Cover3: '/img/tvcardcovers/square/tvcardcoversquare_3.webp',
  Cover4: '/img/tvcardcovers/square/tvcardcoversquare_4.webp',
  Cover5: '/img/tvcardcovers/square/tvcardcoversquare_5.webp',
  Cover6: '/img/tvcardcovers/square/tvcardcoversquare_6.webp',
  Cover7: '/img/tvcardcovers/square/tvcardcoversquare_7.webp',
  Cover8: '/img/tvcardcovers/square/tvcardcoversquare_8.webp',
  Cover9: '/img/tvcardcovers/square/tvcardcoversquare_9.webp',
}

export const $tvCardSquareCovers = createStore(TvCardSquareCoversMap)

register($tvCardSquareCovers, '$shared/ui/cardCovers/tvCardSquareCovers')
